import React, { useState } from 'react'
import { Panel, Row, Col, Icon, IconButton } from 'rsuite'
import { useForm } from 'react-hook-form'
import { startLoading, doneLoading } from '../../utils/loading'
import MiniProjectInfo from '../projectBasedItemsWidget/MiniProjectInfo'
import { downloadFile } from '../../utils/fileUtil'
import {
  downloadSubProjecteReportExport,
  downloadSubProjecteReportExportPdf,
  getSubProjecteReportPage,
} from '../../redux/actions/accountingReport'
import OverlayLoader from '../../components/OverlayLoader/OverlayLoader'
import notification from '../../utils/notification'
import { DEFAULT_ERR_MSG } from '../../constants/msgText'
import SubProjectAccountingReprotTable from './SubProjectAccountingReprotTable'

export default function SubProjectAccountingReprotWidget(props) {
  const { register, handleSubmit, errors, control, getValues, setValue, setError, clearErrors } =
    useForm()

  const [isLoading, setIsLoading] = useState(false)
  const [formSchema, setFormSchema] = useState(props.schema)
  const [isExpanded, setIsExpanded] = useState(true)

  const [displayLength, setDisplayLength] = useState(5)
  const [page, setPage] = useState(1)
  // const [searchRequest, setSearchRequest] = useState({})

  const projectCode = sessionStorage.getItem('projectCode')

  const handleOnExport = async (data) => {
    // console.log('handleOnExport ', data)

    setIsLoading(true)
    startLoading()
    try {
      const file = await downloadSubProjecteReportExport(projectCode)
      // console.log('file ', file)
      if (file) {
        downloadFile(file, `รายงานโครงการย่อย_${projectCode}.xlsx`)
      } else {
        notification.open('error', {
          title: DEFAULT_ERR_MSG,
          duration: 5000,
        })
      }
    } catch (e) {
      console.log('handleExportFile error : ', e)
      notification.open('error', {
        title: e?.errors?.message || DEFAULT_ERR_MSG,
        duration: 5000,
      })
    }
    setIsLoading(false)
    doneLoading()
  }

  const handleOnExportPdf = async (data) => {
    // console.log('handleOnExportPdf')
    setIsLoading(true)
    startLoading()
    try {
      const file = await downloadSubProjecteReportExportPdf(projectCode)
      console.log('file ', file)
      if (file) {
        downloadFile(file, `รายงานโครงการย่อย_${projectCode}.pdf`)
      } else {
        notification.open('error', {
          title: DEFAULT_ERR_MSG,
          duration: 5000,
        })
      }
    } catch (e) {
      console.log('handleExportFile error : ', e)
      notification.open('error', {
        title: e?.errors?.message || DEFAULT_ERR_MSG,
        duration: 5000,
      })
    }
    setIsLoading(false)
    doneLoading()
  }

  const handleSearch = async (pagenumber, pagesize) => {
    setIsLoading(true)
    startLoading()
    try {
      const _schema = await getSubProjecteReportPage(projectCode, pagenumber, pagesize)
      setFormSchema(_schema)
      // console.log('_schema', _schema)
    } catch (e) {
      notification.open('error', {
        title: e?.errors?.message || DEFAULT_ERR_MSG,
        duration: 5000,
      })
    }
    doneLoading()
    setIsLoading(false)
  }

  const onReload = (pagenumber, pagesize) => {
    setPage(pagenumber)
    setDisplayLength(pagesize)
    handleSearch(pagenumber, pagesize)
  }

  return (
    <>
      {isLoading && <OverlayLoader />}

      <Panel
        shaded
        collapsible
        defaultExpanded
        header={formSchema?.form?.header || 'รายงานโครงการย่อย'}
        bordered
        expanded={isExpanded}
        onSelect={() => {
          setIsExpanded(!isExpanded)
        }}
      >
        <MiniProjectInfo schema={formSchema?.projectInfo} />

        <br />

        <Row style={{ marginTop: 10 }}>
          <Col lg={24} md={24} sm={24} xs={24} style={{ textAlign: 'right' }}>
            <IconButton
              appearance="ghost"
              icon={<Icon icon="file-excel-o" className="bt-gost-icon-radius" />}
              onClick={handleSubmit(handleOnExport)}
            >
              Export to MS-Excel
            </IconButton>
            <IconButton
              appearance="ghost"
              icon={<Icon icon="file-pdf-o" className="bt-gost-icon-radius" />}
              style={{ marginLeft: 5 }}
              onClick={handleSubmit(handleOnExportPdf)}
            >
              Export to PDF
            </IconButton>
          </Col>
        </Row>

        <Row style={{ marginTop: 10 }}>
          <SubProjectAccountingReprotTable
            schema={formSchema?.form?.data}
            loading={isLoading}
            onReload={onReload}
            page={page}
            displayLength={displayLength}
          />
        </Row>
      </Panel>
    </>
  )
}
